// eslint-disable-next-line
export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace'
